import httpClient from "Api/httpClient";

const END_POINT = "/orders";

const getOrders = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getOrder = (order_id) => {
    if (!order_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + order_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printOrder = (order_id, view_as = null) => {
    if (!order_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?order_id=" + order_id + "&view_as=" + view_as;
    return httpClient.get(SINGLE_END_POINT);
};

const createOrders = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateOrders = (payload, order_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + order_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteOrders = (order_id) => {
    const DELETE_END_POINT = END_POINT + "/" + order_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const createFeInvoicesFromOrder = (payload, order_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CONVERT_END_POINT = "/fe_invoices/create_from_order/" + order_id;
    return httpClient.post(CONVERT_END_POINT, body);
};

export { getOrders, getOrder, printOrder, createOrders, updateOrders, deleteOrders, createFeInvoicesFromOrder };
